import React from "react";
import { Grid, Paper } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { Identifiable } from "../../models/Identifiable";
import { ExerciseSaleSearchParams } from "../../models/ExerciseSaleSearchParams";
import { useDispatch, useSelector } from "react-redux";
import LoadableComponent from "../../shared/Loading/LoadableComponent";
import { clearExerciseSaleFilters } from "../../store/exerciseSaleFilters/exerciseSaleFiltersActions";
import ExerciseGroupSelector from "../../shared/Selectors/ExerciseGroupSelector";
import { clearSelectExercise } from "../../store/basket/basketActions";
import ZoneSelector from "../../shared/Selectors/ZoneSelector";
import { State } from "../../store";
import BlueButton from "../../shared/BlueButton";

interface IProps {
  loading: boolean;
  searchParams: ExerciseSaleSearchParams;
  setSearchParams: (value: ExerciseSaleSearchParams) => void;
}

const styleContainer = { paddingLeft: "2%", paddingRight: "2%" };

const ExerciseSaleFilter: React.FC<IProps> = ({ loading, searchParams, setSearchParams }: IProps) => {
  const dispatch = useDispatch();
  const clear = () => {
    dispatch(clearSelectExercise());
    dispatch(clearExerciseSaleFilters());
  };

  const groupByZones = useSelector((state: State) => state.config.config.lubinSale_groupByZones);

  return (
    <Paper elevation={3}>
      <Grid container spacing={1} style={styleContainer}>
        <LoadableComponent loading={loading}>
          {groupByZones ? (
            <Grid item xs={5}>
              <ZoneSelector
                zoneIds={searchParams.zoneIds}
                setZoneIds={(zoneIds: Identifiable) => setSearchParams({ ...searchParams, zoneIds })}
                date={searchParams.dateFrom}
              />
            </Grid>
          ) : (
            <Grid item xs={4}>
              <ExerciseGroupSelector
                exerciseGroup={searchParams.exerciseGroupIds}
                setExerciseGroup={(exerciseGroupIds: Identifiable) =>
                  setSearchParams({ ...searchParams, exerciseGroupIds })
                }
                date={searchParams.dateFrom}
              />
            </Grid>
          )}
        </LoadableComponent>
        <Grid item xs={3}>
          <DatePicker
            disablePast
            style={{ width: "100%" }}
            margin={"dense"}
            label="Data od"
            format={"yyyy-MM-dd"}
            value={searchParams.dateFrom}
            onChange={(date: MaterialUiPickersDate) => {
              setSearchParams({
                ...searchParams,
                dateFrom: date ? new Date(date) : new Date(),
                dateTo: date ? new Date(date) : new Date(),
              });
              dispatch(clearSelectExercise());
            }}
            inputVariant="outlined"
            autoOk
          />
        </Grid>

        <Grid item xs={1} style={{ marginTop: "8px" }}>
          <BlueButton clickFn={() => clear()} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ExerciseSaleFilter;
